interface IFieldNameMap {
    [fieldName: string]: string;
}

export class FieldHelper {
    public static readonly FIELD_ORDER = [
        "nodeBackedPathIds_302", // Division
        "nodeBackedPathIds_303", // Business Area
        "nodeBackedPathIds_301", // Keywords a.k.a. Product Category
        "nodeBackedPathIds_304", // Product Family
        "nodeBackedPathIds_312", // Document Type
        "nodeBackedPathIds_307", // Language
        "nodeBackedPathIds_313", // Image Type
        "mediaTypeNameMapped" // Media Type
    ];

    public static readonly PRETTY_NAMES: IFieldNameMap = {
        "customFields_text_342_en": "Description",
        "nodeBackedPathIds_301": "Product Category",
        "nodeBackedPathIds_302": "Division",
        "nodeBackedPathIds_303": "Business Area",
        "nodeBackedPathIds_307": "Language",
        "nodeBackedPathIds_304": "Product Family",
        "nodeBackedPathIds_312": "Document Type",
        "nodeBackedPathIds_313": "Image Type",
        "mediaTypeNameMapped": "Media Type"
    };

    public static getPrettyName(name: string) {
        if (FieldHelper.PRETTY_NAMES[name]) {
            return FieldHelper.PRETTY_NAMES[name];
        } else {
            return name;
        }
    }

    public static getFieldOrderSortResult(a: string, b: string): number {
        return this.getFieldIndex(a) - this.getFieldIndex(b);
    }

    private static getFieldIndex(id: string) {
        if (FieldHelper.FIELD_ORDER.includes(id)) {
            return FieldHelper.FIELD_ORDER.indexOf(id);
        }
        return Number.MAX_SAFE_INTEGER;
    }
}
